
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaitogoacabs() {



    const cardData =
    {
        keyword: 'Mumbai to Goa Cabs',
        heading: 'Skyline Cabs: Mumbai to Goa Cabs',
        headingDescription: 'Skyline Cabs offers comfortable and reliable Mumbai to Goa Cabs for a perfect coastal getaway. Whether you are heading to Goa for a beach vacation, party trip, or a peaceful retreat, our well-maintained vehicles and professional drivers ensure a smooth and enjoyable ride. Enjoy door-to-door pickups from anywhere in Mumbai, transparent pricing, flexible travel schedules, and 24/7 customer support. Book your Mumbai to Goa cab with Skyline Cabs today and experience a hassle-free journey to India’s favorite beach destination!',

        top: 'Top Places to Visit in Goa with Skyline Cabs',

"topPlaces": [
    {
        "title": "Calangute Beach",
        "description": "Often called the 'Queen of Beaches', Calangute is one of Goa’s most popular beaches, known for its lively atmosphere, water sports, beach shacks, and vibrant nightlife."
    },
    {
        "title": "Basilica of Bom Jesus",
        "description": "A UNESCO World Heritage Site in Old Goa, this 16th-century church holds the mortal remains of St. Francis Xavier. Its Baroque architecture and historical significance make it a must-visit for history lovers."
    },
    {
        "title": "Fort Aguada",
        "description": "Overlooking the Arabian Sea, Fort Aguada is a 17th-century Portuguese fort that offers panoramic views and houses an old lighthouse. It’s a great spot for photography and sunset watching."
    },
    {
        "title": "Baga Beach",
        "description": "Known for its buzzing nightlife, beach parties, and popular clubs like Tito’s and Mambo’s, Baga Beach is a favorite among young travelers and partygoers."
    },
    {
        "title": "Anjuna Flea Market",
        "description": "Held every Wednesday, this vibrant market is a hub for quirky fashion, handicrafts, jewelry, and souvenirs. It reflects Goa’s boho-chic vibe and hippie heritage."
    },
    {
        "title": "Dudhsagar Waterfalls",
        "description": "Located on the Goa-Karnataka border, these majestic four-tiered waterfalls resemble a stream of milk flowing down the rocks. It’s a popular day-trip destination for nature and adventure lovers."
    },
    {
        "title": "Palolem Beach",
        "description": "This crescent-shaped beach in South Goa is known for its serene beauty, silent discos, and relaxed vibe. Ideal for couples and solo travelers looking for tranquility."
    },
    {
        "title": "Chapora Fort",
        "description": "Made famous by the movie *Dil Chahta Hai*, this historic fort offers stunning views of Vagator Beach and the Arabian Sea. It’s a great spot for photography and romantic sunsets."
    },
    {
        "title": "Fontainhas Latin Quarter",
        "description": "Located in Panaji, Fontainhas is a charming neighborhood with Portuguese-style houses, narrow lanes, and colorful facades. It’s perfect for a heritage walk and experiencing old-world Goa."
    },
    {
        "title": "Shri Manguesh Temple",
        "description": "One of the most prominent Hindu temples in Goa, dedicated to Lord Shiva, it’s known for its elegant architecture, tall lamp tower, and spiritual ambiance."
    }
]
,

"services": [
    {
      "name": "Mumbai to Goa Cabs",
      "description": "Skyline Cabs offers comfortable and convenient taxi services from Mumbai to Goa. Our cabs are fully equipped for long journeys, providing a smooth and relaxing ride to the beautiful beaches of Goa."
    },
    {
      "name": "Mumbai to Goa Taxi Service",
      "description": "Choose Skyline Cabs for a reliable taxi service from Mumbai to Goa. We ensure punctuality, comfort, and a stress-free travel experience as you journey towards Goa's serene coastal beauty."
    },
    {
      "name": "Mumbai to Goa Cab Fare",
      "description": "The fare for a taxi ride from Mumbai to Goa depends on the type of vehicle you choose and the distance covered. We offer competitive rates for our cab services, ensuring great value for money."
    },
    {
      "name": "Goa Cab Service from Mumbai",
      "description": "Skyline Cabs provides a premium taxi service for your journey from Mumbai to Goa. Whether you are traveling for business or leisure, our cabs are ready to offer comfort and safety."
    },
    {
      "name": "Mumbai to Goa One Way Cab",
      "description": "Book a one-way cab from Mumbai to Goa with Skyline Cabs. This service ensures you have a hassle-free ride to Goa and is perfect for those looking to travel one way only."
    },
    {
      "name": "Taxi from Mumbai to Goa",
      "description": "Get a taxi from Mumbai to Goa with Skyline Cabs. Our service guarantees a comfortable and safe ride with experienced drivers, ensuring you reach your destination on time."
    },
    {
      "name": "Mumbai Goa Cab Booking",
      "description": "Booking a cab for your journey from Mumbai to Goa is easy with Skyline Cabs. You can book your taxi in advance through our online platform or contact us directly to arrange your travel."
    }
  ],
  "tableData": [
    ["Mumbai to Goa Cabs", "Mumbai to Goa Taxi Service"],
    ["Mumbai to Goa Cab Fare", "Goa Cab Service from Mumbai"],
    ["Mumbai to Goa One Way Cab", "Taxi from Mumbai to Goa"],
    ["Mumbai Goa Cab Booking"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Mumbai to Goa Cab Service",
        "WhyChoosedescription": "Enjoy a seamless and dependable Mumbai to Goa cab service with us. Whether you're heading for a beach vacation or a business trip, we ensure a smooth and comfortable journey."
    },
    {
        "WhyChooseheading": "Comfortable and Long-Distance Ready Cabs",
        "WhyChoosedescription": "Our cabs are equipped for long journeys, offering spacious seating, smooth suspension, and a comfortable ride perfect for the scenic Mumbai to Goa drive."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "We provide budget-friendly and transparent pricing for Mumbai to Goa cab rentals. No hidden charges—just straightforward, honest rates you can trust."
    },
    {
        "WhyChooseheading": "Experienced and Polite Drivers",
        "WhyChoosedescription": "Our drivers are experienced with long-distance routes and are courteous, punctual, and focused on delivering a safe and enjoyable ride from Mumbai to Goa."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
        "WhyChoosedescription": "Every vehicle is thoroughly cleaned, sanitized, and maintained to ensure top-notch comfort, safety, and hygiene for your road trip to Goa."
    },
    {
        "WhyChooseheading": "Flexible Travel Options",
        "WhyChoosedescription": "Whether it’s a one-way trip, round trip, or multi-day stay, we offer flexible packages that cater to your travel plans from Mumbai to Goa."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Easy Booking",
        "WhyChoosedescription": "Book your Mumbai to Goa cab online or over the phone with ease. Our 24/7 customer support team ensures a quick and hassle-free booking process."
    },
    {
        "WhyChooseheading": "Perfect for Vacations, Business, or Group Travel",
        "WhyChoosedescription": "Whether it’s a friends’ getaway, a family holiday, or a business visit, our cabs provide the comfort and reliability you need for a memorable Mumbai to Goa trip."
    }
]









    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Mumbai to Goa with Skyline Cabs?',
            answer:
                'Booking a cab from Mumbai to Goa is simple and convenient. You can book through our website, mobile app, or by calling our customer support. Just enter your pickup location, travel date, and select your preferred vehicle for the journey.',
        },
        {
            id: 2,
            question: 'What is the distance and travel time from Mumbai to Goa?',
            answer:
                'The distance from Mumbai to Goa is approximately 590 km. The travel time usually ranges from 9 to 11 hours, depending on traffic and road conditions. Our drivers take the best routes to ensure a smooth and timely journey.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for the Mumbai to Goa trip?',
            answer:
                'We offer a variety of vehicles for the Mumbai to Goa journey, including Swift Dzire, Ertiga, Innova Crysta, Kia Carens, and SUVs. For larger groups, we provide Tempo Travellers and luxury coaches.',
        },
        {
            id: 4,
            question: 'Are your cab fares for Mumbai to Goa fixed?',
            answer:
                'Yes, we provide fixed and transparent pricing for your Mumbai to Goa journey. The fare includes vehicle rental, driver charges, fuel, tolls, taxes, and any applicable service fees. You will know the total fare before confirming your booking.',
        },
        {
            id: 5,
            question: 'Can I book a one-way cab from Mumbai to Goa?',
            answer:
                'Yes, we offer one-way cab options for your convenience. You can choose a round-trip service if you plan to return to Mumbai at a later time.',
        },
        {
            id: 6,
            question: 'What is the best time to travel from Mumbai to Goa?',
            answer:
                'The best time to travel to Goa is during the cooler months from October to March. However, Skyline Cabs operates year-round, and our drivers are experienced in handling different weather conditions.',
        },
        {
            id: 7,
            question: 'Are stopovers allowed during the Mumbai to Goa journey?',
            answer:
                'Yes, we allow short stopovers for refreshments, meals, or sightseeing along the way. Let the driver know if you wish to take a break or explore any specific spots on the route.',
        },
        {
            id: 8,
            question: 'What payment options are available for the Mumbai to Goa cab?',
            answer:
                'We accept various payment methods, including UPI, credit/debit cards, net banking, and cash payments after the trip. All online payments are secure and processed through trusted gateways.',
        },
        {
            id: 9,
            question: 'Can I cancel or modify my Mumbai to Goa cab booking?',
            answer:
                'Yes, you can modify or cancel your booking easily via our website, mobile app, or by contacting customer support. We offer flexible cancellation policies to accommodate changes in your plans.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for the Mumbai to Goa trip?',
            answer:
                'Skyline Cabs offers a comfortable, safe, and reliable journey to Goa. We provide well-maintained vehicles, experienced drivers, and transparent pricing. Our excellent customer service ensures that your trip is enjoyable and hassle-free.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "Our road trip from Mumbai to Goa with Skyline Cabs was fantastic. The car was spacious and comfortable, and the driver was very polite and skilled. Highly recommended for long journeys!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "Had a great trip from Mumbai to Goa with Skyline Cabs. The journey was smooth, and the driver was professional. It would’ve been better if the AC was a little cooler, but otherwise, everything was great!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Goa Cab",
  "image": "https://skylinecabs.com/assets/images/mumbai-to-goa-cab.jpg",
  "description": "Book Mumbai to Goa Cab with Skyline Cabs for a scenic coastal ride. Choose from AC sedans, SUVs, or luxury tempo travellers for a safe and comfortable long-distance journey with professional drivers, available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8893"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7500",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-to-goa-cab"
  }
};

    
      

    return (
        <div>
  
<Helmet>
  <title>Mumbai to Goa Cab | AC Sedan & SUV Taxi Booking | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Goa Cab with Skyline Cabs for a scenic coastal ride. Choose from AC sedans, SUVs, or luxury tempo travellers for a safe and comfortable long-distance journey with professional drivers, available 24/7." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Goa Cab, Mumbai to Goa Taxi Service, SUV Cab Mumbai to Goa, AC Sedan Taxi to Goa, Luxury Cab to Goa from Mumbai, One Way Cab Mumbai Goa, Skyline Cabs Goa Taxi, Online Cab Booking Mumbai to Goa" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/84.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitogoacabs;